module.exports = __webpack_public_path__ + "static/img/home-bg-image20.3692e88.png";


//////////////////
// WEBPACK FOOTER
// ./src/newpage/static/images/home-bg-image20.png
// module id = gPlV
// module chunks = 1